import CRUDService from "../../services/base/CRUDService";

export default class BeaconService extends CRUDService {

  getBaseURL() {
    return 'integration/v1/beacons/';
  }

  findAllPolicy() {
    return this.getHttpRequest().get('integration/v1/policies');
  }
}



// WEBPACK FOOTER //
// ./src/bluzone/beacon/BeaconService.js